"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntitlementFromTopicType = exports.productMapping = void 0;
const models_1 = require("../models");
const utils_1 = require("../utils");
const enums_1 = require("./enums");
const ALL_TOPIC_TYPE_WITHOUT_ANATOMY = [
    models_1.ETopicType.CLINICAL,
    models_1.ETopicType.DATA_INTERPRETATION,
    models_1.ETopicType.PRE_CLINICAL,
];
const ALL_TOPIC_TYPE = [models_1.ETopicType.ANATOMY, ...ALL_TOPIC_TYPE_WITHOUT_ANATOMY];
const ALL_MOCKS_WITHOUT_ANATOMY = [
    models_1.EMockTestType.FINALS,
    models_1.EMockTestType.PSA,
    models_1.EMockTestType.MISCELLANEOUS,
    models_1.EMockTestType.UNIVERSITY_SPECIFIC,
    models_1.EMockTestType.UKMLA,
    models_1.EMockTestType.UKMLA_FULL,
];
const ALL_MOCKS = [models_1.EMockTestType.ANATOMY_SPOTTER, ...ALL_MOCKS_WITHOUT_ANATOMY];
exports.productMapping = {
    [models_1.EProductType.QBANK]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: ALL_TOPIC_TYPE_WITHOUT_ANATOMY,
        mockType: ALL_MOCKS_WITHOUT_ANATOMY,
    },
    [models_1.EProductType.OSCE]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: ALL_TOPIC_TYPE,
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.BUNDLE]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: ALL_TOPIC_TYPE_WITHOUT_ANATOMY,
        mockType: ALL_MOCKS_WITHOUT_ANATOMY,
    },
    [models_1.EProductType.ANATOMY]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.ANATOMY],
        mockType: [models_1.EMockTestType.ANATOMY_SPOTTER],
    },
    [models_1.EProductType.MEDICAL_SCIENCES]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.PRE_CLINICAL, models_1.ETopicType.CLINICAL],
        mockType: [models_1.EMockTestType.UNIVERSITY_SPECIFIC],
    },
    [models_1.EProductType.ANATOMY_BUNDLE]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.ANATOMY, models_1.ETopicType.PRE_CLINICAL],
        mockType: [
            models_1.EMockTestType.ANATOMY_SPOTTER,
            models_1.EMockTestType.UNIVERSITY_SPECIFIC,
        ],
    },
    [models_1.EProductType.MRCP_PART1]: {
        db: enums_1.DB_TYPE.MRCP,
        topicType: [models_1.ETopicType.CLINICAL],
        mockType: [models_1.EMockTestType.MRCP],
    },
    [models_1.EProductType.MRCP_PART2]: {
        db: enums_1.DB_TYPE.MRCP,
        topicType: [models_1.ETopicType.CLINICAL],
        mockType: [models_1.EMockTestType.MRCP],
    },
    [models_1.EProductType.PACES]: {
        db: enums_1.DB_TYPE.MRCP,
        topicType: [models_1.ETopicType.OSCE],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.MSRA]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.CLINICAL],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.INTERVIEW_ANAESTHETICS]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.INTERVIEW_ANAESTHETICS],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.INTERVIEW_CST]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.INTERVIEW_CST],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.INTERVIEW_IMT]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.INTERVIEW_IMT],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.INTERVIEW_RADIOLOGY]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.INTERVIEW_RADIOLOGY],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.INTERVIEW_PAEDIATRICS]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.INTERVIEW_PAEDIATRICS],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.PLAB1]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: [models_1.ETopicType.CLINICAL],
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.PLAB2]: {
        db: enums_1.DB_TYPE.FINALS,
        topicType: ALL_TOPIC_TYPE,
        mockType: ALL_MOCKS,
    },
    [models_1.EProductType.UCAT]: {
        db: enums_1.DB_TYPE.UCAT,
        topicType: [],
        mockType: [
            models_1.EMockTestType.FULL_MOCK,
            models_1.EMockTestType.VERBAL_REASONING,
            models_1.EMockTestType.DECISION_MAKING,
            models_1.EMockTestType.QUANTITATIVE_REASONING,
            models_1.EMockTestType.SITUATIONAL_JUDGEMENT,
        ],
    },
    [models_1.EProductType.MRCP_VIDEO]: {
        db: enums_1.DB_TYPE.MRCP,
        topicType: [models_1.ETopicType.CLINICAL],
        mockType: [],
    },
};
const topicEntitlementMap = {
    [models_1.ETopicType.PRE_CLINICAL]: models_1.EEntitlementType.PRE_CLINICAL,
    [models_1.ETopicType.CLINICAL]: models_1.EEntitlementType.CLINICAL,
    [models_1.ETopicType.ANATOMY]: models_1.EEntitlementType.ANATOMY,
    [models_1.ETopicType.DATA_INTERPRETATION]: models_1.EEntitlementType.DATA_INTERPRETATION,
    [models_1.ETopicType.SJT]: models_1.EEntitlementType.PROFESSIONAL_DILEMMA,
    [models_1.ETopicType.INTERVIEW_ANAESTHETICS]: models_1.EEntitlementType.INTERVIEW_ANAESTHETICS,
    [models_1.ETopicType.INTERVIEW_CST]: models_1.EEntitlementType.INTERVIEW_CST,
    [models_1.ETopicType.INTERVIEW_IMT]: models_1.EEntitlementType.INTERVIEW_IMT,
    [models_1.ETopicType.INTERVIEW_RADIOLOGY]: models_1.EEntitlementType.INTERVIEW_RADIOLOGY,
    [models_1.ETopicType.INTERVIEW_PAEDIATRICS]: models_1.EEntitlementType.INTERVIEW_PAEDIATRICS,
    [models_1.ETopicType.UCAT]: models_1.EEntitlementType.VERBAL_REASONING,
};
const osceEntitlementMap = {
    [models_1.EOsceType.HISTORY_TAKING]: models_1.EEntitlementType.HISTORY_TAKING,
    [models_1.EOsceType.COMMUNICATION_SKILLS]: models_1.EEntitlementType.COMMUNICATION_SKILLS,
    [models_1.EOsceType.EXAMINATION]: models_1.EEntitlementType.EXAMINATION,
    [models_1.EOsceType.PROCEDURE]: models_1.EEntitlementType.PROCEDURE,
    [models_1.EOsceType.INTERPRETATION]: models_1.EEntitlementType.INTERPRETATION,
    [models_1.EOsceType.ABCDE]: models_1.EEntitlementType.ABCDE,
    [models_1.EOsceType.PRESCRIBING]: models_1.EEntitlementType.PRESCRIBING,
    [models_1.EOsceType.MIXED]: models_1.EEntitlementType.MIXED,
};
const paceEntitlementMap = {
    [models_1.EPaceType.ABDOMINAL]: models_1.EEntitlementType.ABDOMINAL,
    [models_1.EPaceType.CARDIOVASCULAR]: models_1.EEntitlementType.CARDIOVASCULAR,
    [models_1.EPaceType.COMMUNICATION]: models_1.EEntitlementType.COMMUNICATION,
    [models_1.EPaceType.CONSULTATION]: models_1.EEntitlementType.CONSULTATION,
    [models_1.EPaceType.NEUROLOGY]: models_1.EEntitlementType.NEUROLOGY,
    [models_1.EPaceType.RESPIRATORY]: models_1.EEntitlementType.RESPIRATORY,
};
const clinicalEntitlementMap = {
    [models_1.EProductType.MEDICAL_SCIENCES]: models_1.EEntitlementType.CLINICAL_SUBSET,
    [models_1.EProductType.QBANK]: models_1.EEntitlementType.CLINICAL,
    [models_1.EProductType.MSRA]: models_1.EEntitlementType.CLINICAL_PROBLEM_SOLVING,
    [models_1.EProductType.PLAB1]: models_1.EEntitlementType.PLAB_1,
    [models_1.EProductType.MRCP_PART1]: models_1.EEntitlementType.MRCP_PART_1,
    [models_1.EProductType.MRCP_PART2]: models_1.EEntitlementType.MRCP_PART_2,
    [models_1.EProductType.MRCP_VIDEO]: models_1.EEntitlementType.MRCP_VIDEO,
};
const getEntitlementFromTopicType = (typeId, productType, entitlementInfo) => {
    let entitlement;
    switch (productType) {
        case models_1.EProductType.PACES: {
            entitlement = paceEntitlementMap[typeId];
            break;
        }
        case models_1.EProductType.UCAT: {
            if (entitlementInfo) {
                entitlement = entitlementInfo;
                break;
            }
        }
        case models_1.EProductType.OSCE:
        case models_1.EProductType.PLAB2: {
            entitlement = osceEntitlementMap[typeId];
            break;
        }
        case models_1.EProductType.MSRA: {
            if (entitlementInfo) {
                entitlement = entitlementInfo;
                break;
            }
        }
        default: {
            entitlement =
                typeId === models_1.ETopicType.CLINICAL
                    ? clinicalEntitlementMap[productType]
                    : topicEntitlementMap[typeId];
            break;
        }
    }
    if (!entitlement) {
        return { id: 0, name: 'Unknown' };
    }
    return { id: entitlement, name: (0, utils_1.titleCase)(models_1.EEntitlementType[entitlement]) };
};
exports.getEntitlementFromTopicType = getEntitlementFromTopicType;
